<h2 mat-dialog-title>Fecha de Liquidación</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <p class="mensaje">{{ mensaje }}</p>

    <mat-form-field  class="full-width">
      <mat-label>Fecha de Cierre</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        formControlName="fechaCierre"
        placeholder="Seleccione una fecha"
        required>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="form.controls['fechaCierre'].hasError('required')">
        La fecha es obligatoria
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancelar()">
    Cancelar
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onAceptar()"
    [disabled]="!form.valid">
    Aceptar
  </button>
</mat-dialog-actions>
